export const messages = {
  page: {
    singleSignOnFailed: {
      id: 'singleSignOn.FailedMessage',
      defaultMessage: `You are unable to log in. It's possible that you do not have an account on this site, 
        or that your access has been restricted. Please contact your care provider for more information.`,
    },
    singleSignOnFailedTitle: {
      id: 'singleSignOn.LoginFailedTitle',
      defaultMessage: 'Login Failed',
    },
  },
};
